export const personMocked = {
  customerNo: '74946',
  firstName: 'Carmen',
  lastName: 'Watson',
  jobTitle: 'Test Engineer',
  companyName: 'LEVITON MANUFACTURING CO.',
  claims: [
    {
      sourceSystem: 'Fineos',
      claimId: 'NTN-16691-GDC-02',
      parentId: 'NTN-16691',
      claimType: 'Group Disability Claim',
      status: 'Open',
      createdDate: '2022-10-28',
      notificationDate: '2022-10-28',
      lastWorkedDate: '',
      firstDayMissedWork: '',
      pregnancy: {},
      payments: [],
    },
    {
      sourceSystem: 'Fineos',
      claimId: 'NTN-20736-GDC-02',
      parentId: 'NTN-20736',
      claimType: 'Group Disability Claim',
      status: 'Open',
      createdDate: '2023-01-05',
      notificationDate: '2023-01-05',
      lastWorkedDate: '',
      firstDayMissedWork: '',
      pregnancy: {},
      payments: [],
    },
  ],
  leaves: [
    {
      sourceSystem: 'Fineos',
      leaveId: 'NTN-20736-ABS-01',
      eventName: '',
      parentId: 'NTN-20736',
      createdDate: '2023-01-05',
      notificationDate: '2023-01-05',
      status: 'Adjudication',
      startDate: '2023-01-05',
      endDate: '2023-03-28',
      reason: 'Pregnancy/Maternity',
      reasonQualifier1: 'Birth Disability',
      reasonQualifier2: '',
    },
    {
      sourceSystem: 'Fineos',
      leaveId: 'NTN-16691-ABS-01',
      eventName: '',
      parentId: 'NTN-16691',
      createdDate: '2022-10-28',
      notificationDate: '2022-10-28',
      status: 'Closed',
      startDate: '2022-10-06',
      endDate: '2022-12-23',
      reason: 'Serious Health Condition - Employee',
      reasonQualifier1: 'Not Work Related',
      reasonQualifier2: 'Sickness',
    },
  ],
  accommodations: [
    {
      accommodationId: 'NTN-23831-ACM-01',
      sourceSystem: 'Fineos',
      status: 'Closed',
      createdDate: '2023-02-23',
      parentId: 'NTN-23831',
      notificationDate: '2023-02-23',
    },
  ],
};

export const personDataMockGenerated = {
  customerNo: '74946',
  firstName: 'Carmen',
  lastName: 'Watson',
  jobTitle: 'Test Engineer',
  companyName: 'LEVITON MANUFACTURING CO.',
  claims: [
    {
      sourceSystem: 'Fineos',
      claimId: 'NTN-16691-GDC-02',
      parentId: 'NTN-16691',
      claimType: 'Group Disability Claim',
      status: 'Open',
      createdDate: '2022-10-28',
      notificationDate: '2022-10-28',
      lastWorkedDate: '',
      firstDayMissedWork: '',
      pregnancy: {},
      payments: [],
    },
    {
      sourceSystem: 'Fineos',
      claimId: 'NTN-20736-GDC-02',
      parentId: 'NTN-20736',
      claimType: 'Group Disability Claim',
      status: 'Open',
      createdDate: '2023-01-05',
      notificationDate: '2023-01-05',
      lastWorkedDate: '',
      firstDayMissedWork: '',
      pregnancy: {},
      payments: [],
    },
  ],
  leaves: [
    {
      sourceSystem: 'Fineos',
      leaveId: 'NTN-20736-ABS-01',
      eventName: '',
      parentId: 'NTN-20736',
      createdDate: '2023-01-05',
      notificationDate: '2023-01-05',
      status: 'Adjudication',
      startDate: '2023-01-05',
      endDate: '2023-03-28',
      reason: 'Pregnancy/Maternity',
      reasonQualifier1: 'Birth Disability',
      reasonQualifier2: '',
    },
    {
      sourceSystem: 'Fineos',
      leaveId: 'NTN-16691-ABS-01',
      eventName: '',
      parentId: 'NTN-16691',
      createdDate: '2022-10-28',
      notificationDate: '2022-10-28',
      status: 'Closed',
      startDate: '2022-10-06',
      endDate: '2022-12-23',
      reason: 'Serious Health Condition - Employee',
      reasonQualifier1: 'Not Work Related',
      reasonQualifier2: 'Sickness',
    },
  ],
  accommodations: [
    {
      accommodationId: 'NTN-23831-ACM-01',
      sourceSystem: 'Fineos',
      status: 'Closed',
      createdDate: '2023-02-23',
      parentId: 'NTN-23831',
      notificationDate: '2023-02-23',
    },
  ],
  cases: [
    {
      caseId: 'NTN-23831',
      earliestNotificationDate: '2023-02-23',
      integrated: false,
      subcases: [
        {
          accommodationId: 'NTN-23831-ACM-01',
          sourceSystem: 'Fineos',
          status: 'Closed',
          createdDate: '2023-02-23',
          parentId: 'NTN-23831',
          notificationDate: '2023-02-23',
          caseId: 'NTN-23831-ACM-01',
          caseReason: 'Accommodation Case',
          caseStartDate: '2023-02-23',
          caseStatus: 'Closed',
        },
      ],
      isParent: true,
    },
    {
      caseId: 'NTN-20736',
      earliestNotificationDate: '2023-01-05',
      integrated: true,
      subcases: [
        {
          sourceSystem: 'Fineos',
          leaveId: 'NTN-20736-ABS-01',
          eventName: '',
          parentId: 'NTN-20736',
          createdDate: '2023-01-05',
          notificationDate: '2023-01-05',
          status: 'Adjudication',
          startDate: '2023-01-05',
          endDate: '2023-03-28',
          reason: 'Pregnancy/Maternity',
          reasonQualifier1: 'Birth Disability',
          reasonQualifier2: '',
          caseId: 'NTN-20736-ABS-01',
          caseReason: 'Pregnancy/Maternity',
          caseStartDate: '2023-01-05',
          caseStatus: 'Adjudication',
        },
        {
          sourceSystem: 'Fineos',
          claimId: 'NTN-20736-GDC-02',
          parentId: 'NTN-20736',
          claimType: 'Group Disability Claim',
          status: 'Open',
          createdDate: '2023-01-05',
          notificationDate: '2023-01-05',
          lastWorkedDate: '',
          firstDayMissedWork: '',
          pregnancy: {},
          payments: [],
          caseId: 'NTN-20736-GDC-02',
          caseReason: 'Group Disability Claim',
          caseStartDate: '2023-01-05',
          caseStatus: 'Open',
        },
      ],
      isParent: true,
    },
    {
      caseId: 'NTN-16691',
      earliestNotificationDate: '2022-10-28',
      integrated: true,
      subcases: [
        {
          sourceSystem: 'Fineos',
          leaveId: 'NTN-16691-ABS-01',
          eventName: '',
          parentId: 'NTN-16691',
          createdDate: '2022-10-28',
          notificationDate: '2022-10-28',
          status: 'Closed',
          startDate: '2022-10-06',
          endDate: '2022-12-23',
          reason: 'Serious Health Condition - Employee',
          reasonQualifier1: 'Not Work Related',
          reasonQualifier2: 'Sickness',
          caseId: 'NTN-16691-ABS-01',
          caseReason: 'Serious Health Condition - Employee',
          caseStartDate: '2022-10-06',
          caseStatus: 'Closed',
        },
        {
          sourceSystem: 'Fineos',
          claimId: 'NTN-16691-GDC-02',
          parentId: 'NTN-16691',
          claimType: 'Group Disability Claim',
          status: 'Open',
          createdDate: '2022-10-28',
          notificationDate: '2022-10-28',
          lastWorkedDate: '',
          firstDayMissedWork: '',
          pregnancy: {},
          payments: [],
          caseId: 'NTN-16691-GDC-02',
          caseReason: 'Group Disability Claim',
          caseStartDate: '2022-10-28',
          caseStatus: 'Open',
        },
      ],
      isParent: true,
    },
  ],
};

export const mockedGeneratedPerson = {
  customerNo: '74946',
  firstName: 'Carmen',
  lastName: 'Watson',
  jobTitle: 'Test Engineer',
  companyName: 'LEVITON MANUFACTURING CO.',
  claims: [
    {
      sourceSystem: 'Fineos',
      claimId: 'NTN-16691-GDC-02',
      parentId: 'NTN-16691',
      claimType: 'Group Disability Claim',
      status: 'Open',
      createdDate: '2022-10-28',
      notificationDate: '2022-10-28',
      lastWorkedDate: '',
      firstDayMissedWork: '',
      pregnancy: {},
      payments: [],
    },
    {
      sourceSystem: 'Fineos',
      claimId: 'NTN-20736-GDC-02',
      parentId: 'NTN-20736',
      claimType: 'Group Disability Claim',
      status: 'Open',
      createdDate: '2023-01-05',
      notificationDate: '2023-01-05',
      lastWorkedDate: '',
      firstDayMissedWork: '',
      pregnancy: {},
      payments: [],
    },
  ],
  leaves: [
    {
      sourceSystem: 'Fineos',
      leaveId: 'NTN-20736-ABS-01',
      eventName: '',
      parentId: 'NTN-20736',
      createdDate: '2023-01-05',
      notificationDate: '2023-01-05',
      status: 'Adjudication',
      startDate: '2023-01-05',
      endDate: '2023-03-28',
      reason: 'Pregnancy/Maternity',
      reasonQualifier1: 'Birth Disability',
      reasonQualifier2: '',
    },
    {
      sourceSystem: 'Fineos',
      leaveId: 'NTN-16691-ABS-01',
      eventName: '',
      parentId: 'NTN-16691',
      createdDate: '2022-10-28',
      notificationDate: '2022-10-28',
      status: 'Closed',
      startDate: '2022-10-06',
      endDate: '2022-12-23',
      reason: 'Serious Health Condition - Employee',
      reasonQualifier1: 'Not Work Related',
      reasonQualifier2: 'Sickness',
    },
  ],
  cases: [
    {
      caseId: 'NTN-20736',
      earliestNotificationDate: '2023-01-05',
      integrated: true,
      subcases: [
        {
          sourceSystem: 'Fineos',
          leaveId: 'NTN-20736-ABS-01',
          eventName: '',
          parentId: 'NTN-20736',
          createdDate: '2023-01-05',
          notificationDate: '2023-01-05',
          status: 'Adjudication',
          startDate: '2023-01-05',
          endDate: '2023-03-28',
          reason: 'Pregnancy/Maternity',
          reasonQualifier1: 'Birth Disability',
          reasonQualifier2: '',
          caseId: 'NTN-20736-ABS-01',
          caseReason: 'Pregnancy/Maternity',
          caseStartDate: '2023-01-05',
          caseStatus: 'Adjudication',
        },
        {
          sourceSystem: 'Fineos',
          claimId: 'NTN-20736-GDC-02',
          parentId: 'NTN-20736',
          claimType: 'Group Disability Claim',
          status: 'Open',
          createdDate: '2023-01-05',
          notificationDate: '2023-01-05',
          lastWorkedDate: '',
          firstDayMissedWork: '',
          pregnancy: {},
          payments: [],
          caseId: 'NTN-20736-GDC-02',
          caseReason: 'Group Disability Claim',
          caseStartDate: '2023-01-05',
          caseStatus: 'Open',
        },
      ],
      isParent: true,
    },
    {
      caseId: 'NTN-16691',
      earliestNotificationDate: '2022-10-28',
      integrated: true,
      subcases: [
        {
          sourceSystem: 'Fineos',
          leaveId: 'NTN-16691-ABS-01',
          eventName: '',
          parentId: 'NTN-16691',
          createdDate: '2022-10-28',
          notificationDate: '2022-10-28',
          status: 'Closed',
          startDate: '2022-10-06',
          endDate: '2022-12-23',
          reason: 'Serious Health Condition - Employee',
          reasonQualifier1: 'Not Work Related',
          reasonQualifier2: 'Sickness',
          caseId: 'NTN-16691-ABS-01',
          caseReason: 'Serious Health Condition - Employee',
          caseStartDate: '2022-10-06',
          caseStatus: 'Closed',
        },
        {
          sourceSystem: 'Fineos',
          claimId: 'NTN-16691-GDC-02',
          parentId: 'NTN-16691',
          claimType: 'Group Disability Claim',
          status: 'Open',
          createdDate: '2022-10-28',
          notificationDate: '2022-10-28',
          lastWorkedDate: '',
          firstDayMissedWork: '',
          pregnancy: {},
          payments: [],
          caseId: 'NTN-16691-GDC-02',
          caseReason: 'Group Disability Claim',
          caseStartDate: '2022-10-28',
          caseStatus: 'Open',
        },
      ],
      isParent: true,
    },
  ],
};
